const transformYear = (year: string) => year.split('_')[0];

export default transformYear;
